export const ATTRIBUTE_LIST_SUCCESS = 'ATTRIBUTE_LIST_SUCCESS';
export const ATTRIBUTE_LIST_FAIL = 'ATTRIBUTE_LIST_FAIL';
export const EDIT_ATTRIBUTES_SUCCESS = 'EDIT_ATTRIBUTES_SUCCESS';
export const EDIT_ATTRIBUTES_FAIL = 'EDIT_ATTRIBUTES_FAIL';
export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';
export const ATTRIBUTE_NAME_SUCCESS = 'ATTRIBUTE_NAME_SUCCESS';
export const DROPDOWN_START = 'DROPDOWN_START';
export const DROPDOWN_END = 'DROPDOWN_END';
export const DROPDOWN_DATA_SUCCESS = 'DROPDOWN_DATA_SUCCESS';
export const DROPDOWN_DATA_VALIDATION_SUCCESS =
  'DROPDOWN_DATA_VALIDATION_SUCCESS';
export const DROPDOWN_MASTER_DATA_SUCCESS = 'DROPDOWN_MASTER_DATA_SUCCESS';
export const CREATE_ATTRIBUTE_HIERARCHY_SUCCESS =
  'CREATE_ATTRIBUTE_HIERARCHY_SUCCESS';
export const ATTRIBUTE_LIST_SINGLE_DATA_SUCCESS =
  'ATTRIBUTE_LIST_SINGLE_DATA_SUCCESS';
export const ENROLLMENT_REQUEST_SETUP_SUCCESS = 'ENROLLMENT_REQUEST_SETUP_SUCCESS';
export const GET_ALL_ENROLLMENT_REQUEST_SETUP_SUCCESS =
  'GET_ALL_ENROLLMENT_REQUEST_SETUP_SUCCESS';
export const GET_ENROLLMENT_REQUEST_SETUP_BY_ID_SUCCESS =
  'GET_ENROLLMENT_REQUEST_SETUP_BY_ID_SUCCESS';
export const GET_ENROLLMENT_REQUEST_SETUP_BY_PROFILE_NAME_SUCCESS =
  'GET_ENROLLMENT_REQUEST_SETUP_BY_PROFILE_NAME_SUCCESS';
export const ATTRIBUTE_MANAGEMENT_LIST_DATA_SUCCESS =
  'ATTRIBUTE_MANAGEMENT_LIST_DATA_SUCCESS';
export const DELETE_ATTRIBUTE_MANAGEMENT_DATA_SUCCESS =
  'DELETE_ATTRIBUTE_MANAGEMENT_DATA_SUCCESS';
export const DELETE_ENROLLMENT_MAPPING_PROFILE_SUCCESS =
  'DELETE_ENROLLMENT_MAPPING_PROFILE_SUCCESS';
export const SAVE_EDIT_ATTRIBUTE_MANAGEMENT_DATA_SUCCESS =
  'SAVE_EDIT_ATTRIBUTE_MANAGEMENT_DATA_SUCCESS';
export const UPDATE_ENROLLMENT_REQUEST_SETUP_SUCCESS =
  'UPDATE_ENROLLMENT_REQUEST_SETUP_SUCCESS';
export const UPLOAD_ATTRIBUTE_MANAGEMENT_FILE_SUCCESS =
  'UPLOAD_ATTRIBUTE_MANAGEMENT_FILE_SUCCESS';
export const CREATE_USER_DEFINED_ATTRIBUTE_SUCCESS = 'CREATE_USER_DEFINED_ATTRIBUTE_SUCCESS';
export const CREATE_USER_DEFINED_ATTRIBUTE_FAIL = 'CREATE_USER_DEFINED_ATTRIBUTE_FAIL';
export const UPDATE_USER_DEFINED_ATTRIBUTE_SUCCESS = 'UPDATE_USER_DEFINED_ATTRIBUTE_SUCCESS';
export const UPDATE_USER_DEFINED_ATTRIBUTE_FAIL = 'UPDATE_USER_DEFINED_ATTRIBUTE_FAIL';
export const GET_ATTRIBUTE_VALUES_SUCCESS = 'GET_ATTRIBUTE_VALUES_SUCCESS';
export const GET_ATTRIBUTE_TYPE_BY_ID_SUCCESS = 'GET_ATTRIBUTE_TYPE_BY_ID_SUCCESS';
export const CLEAR_ATTRIBUTE_TYPE_BY_ID = 'CLEAR_ATTRIBUTE_TYPE_BY_ID';
export const UPDATE_ATTRIBUTE_VALUE_SUCCESS = 'UPDATE_ATTRIBUTE_VALUE_SUCCESS';
export const UPDATE_ATTRIBUTE_VALUE_FAIL = 'UPDATE_ATTRIBUTE_VALUE_FAIL';
export const GET_ATTRIBUTE_DROPDOWN_VALUES = 'GET_ATTRIBUTE_DROPDOWN_VALUES';
export const GET_DATA_TYPES = 'GET_DATA_TYPES';
export const GET_ATTRIBUTE_DROPDOWN_VALUES_HANDSONTABLE = 'GET_ATTRIBUTE_DROPDOWN_VALUES_HANDSONTABLE';
export const GET_ATTRIBUTE_LABELS_SUCCESS = 'GET_ATTRIBUTE_LABELS_SUCCESS';
export const GET_ATTRIBUTE_LABELS_FAILED = 'GET_ATTRIBUTE_LABELS_FAILED';
export const PROCESS_ENROLLMENT_UPDATE_REQUEST_SUCCESS = 'PROCESS_ENROLLMENT_UPDATE_REQUEST_SUCCESS';
export const PROCESS_ENROLLMENT_UPDATE_REQUEST_FAIL = 'PROCESS_ENROLLMENT_UPDATE_REQUEST_FAIL';
export const POST_ENROLLMENT_UPDATE_REQUEST_SUCCESS = 'POST_ENROLLMENT_UPDATE_REQUEST_SUCCESS';
export const POST_ENROLLMENT_UPDATE_REQUEST_FAIL = 'POST_ENROLLMENT_UPDATE_REQUEST_FAIL';
export const GET_ENROLLMENT_UPDATE_REQUEST_SUCCESS = 'GET_ENROLLMENT_UPDATE_REQUEST_SUCCESS';
export const GET_ENROLLMENT_UPDATE_REQUEST_FAIL = 'GET_ENROLLMENT_UPDATE_REQUEST_FAIL';
export const GET_ENROLLMENT_UPDATE_REQUEST_BY_ID_SUCCESS = 'GET_ENROLLMENT_UPDATE_REQUEST_BY_ID_SUCCESS';
export const GET_ENROLLMENT_UPDATE_REQUEST_BY_ID_FAIL = 'GET_ENROLLMENT_UPDATE_REQUEST_BY_ID_FAIL';
export const GET_ENROLLMENT_UPDATE_REQUEST_LIST_SUCCESS = 'GET_ENROLLMENT_UPDATE_REQUEST_LIST_SUCCESS';
export const GET_ENROLLMENT_UPDATE_REQUEST_LIST_FAIL = 'GET_ENROLLMENT_UPDATE_REQUEST_LIST_FAIL';
export const GET_GPO_EXECUTION_LIST_SUCCESS = 'GET_GPO_EXECUTION_LIST_SUCCESS';
export const GET_GPO_EXECUTION_LIST_FAIL = 'GET_GPO_EXECUTION_LIST_FAIL';
export const GET_GPO_EXECUTION_BY_ID_SUCCESS = 'GET_GPO_EXECUTION_BY_ID_SUCCESS';
export const GET_GPO_EXECUTION_BY_ID_FAIL = 'GET_GPO_EXECUTION_BY_ID_FAIL';
export const CLEAR_GPO_EXECUTION_EDIT_CACHE = 'CLEAR_GPO_EXECUTION_EDIT_CACHE';